import { cn } from "@utils/tw"
import { ReactNode, Ref } from "react"

type Props = {
  sidePanel?: ReactNode
  header?: ReactNode
  footer?: ReactNode
  children: ReactNode
  padded?: boolean
  contentRef?: Ref<HTMLDivElement>
}

export function CheckoutStepLayout(props: Props) {
  return (
    <div
      className={cn(
        "p-4 flex flex-col md:flex-row min-h-0 flex-1 gap-4 justify-stretch items-stretch md:min-h-[min(60vh,500px)]",
        props.padded === false && "p-0",
      )}
    >
      {/* Side panel */}
      {props.sidePanel && (
        <div className="min-h-0 flex flex-col flex-1 md:border border-blue md:order-1 md:w-1/3 p-grid-margin md:p-3">
          {props.sidePanel}
        </div>
      )}
      {/* Main content */}
      <div className="flex min-h-0 min-w-0 flex-col flex-1">
        <h2 className="type-title-s">{props.header}</h2>
        <div ref={props.contentRef} className="min-h-0 flex-1 overflow-auto">
          {props.children}
        </div>
        <div className="flex flex-none flex-row gap-2 pt-4">{props.footer}</div>
      </div>
    </div>
  )
}
